import React from 'react';
import { Line, Area, Title, Item } from './styles';
import Bar from '../VerticalDiagram/Bar';
import { BarPlaceHolder } from '../VerticalDiagram/styles';
import { Link } from 'react-router-dom';
import { percentFormat } from '../../Utils/NumberFormatting';
import WithMore from '../WithMore';
import { getCandidateFace } from '../../Utils/Getters';

function Head2HeadList({ roundIndex, faces, items }) {
	return items.map(({ id, name, meta, head2head }) => {
		return <React.Fragment key={id}>
			<Link to={`/obvod/${id}`} style={{ textDecoration: 'none' }}>
				<Line>
					<Item>
						<Area className={Title}>
							{name}
						</Area>
						{meta[roundIndex] && <>
							<div className={Title}>
								Účast: {percentFormat(meta[roundIndex].turnout, 2)}
							</div>
							<div className={Title}>
								Sečteno: {percentFormat(meta[roundIndex].count, 2)}
							</div>
						</>}
					</Item>
					{head2head.map(head =>
						<Bar
							key={head.id}
							roundIndex={roundIndex}
							max={head2head[0].percent[roundIndex]}
							{...head}
							face={getCandidateFace(faces, head.id)}
							full={head2head.length !== 1}
						/>
					)}
					{head2head.length === 1 && <BarPlaceHolder>
						Vyhrává v prvním kole
					</BarPlaceHolder>}
				</Line>
			</Link>
		</React.Fragment>
	})
}

export default WithMore(Head2HeadList, { length: 7 })
